import React, { Component } from "react";
import styled from "styled-components";
import {
  StyledBaseTable
  , StyledLabelDollarFormatted
  , StyledLabelString
} from './styledBaseTable';
import {
  LabelDate
  , LabelString
  , PROPERTY_ASSET_TYPES
  , LabelDollarFormatted
} from '@loanbossinc/component-library';

const StyledUnitCell = styled.div`
  && {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    border: none;  

    span {
      font-family: Work Sans;
      font-style: normal;
      font-size: 12px;
    }

    .unit {
      font-weight: 600;
      color: #5F6368;
      text-transform: uppercase;
    }
  }
`;

export class PropertySoldTable extends Component {
  columns = [
    {
      id: 'address'
      , label: 'ADDRESS'
      , path: 'address'
      , Cell: (value) => <StyledLabelString value={value} />
    }
    , {
      id: 'disposition'
      , label: 'DISPOSITION DATE'
      , path: 'actualExitDate'
      , Cell: (value) => <LabelDate value={value} />
    }
    , {
      id: 'salesPrice'
      , label: 'SALES PRICE'
      , path: 'salesPrice'
      , Cell: (value) => <StyledLabelDollarFormatted value={value} />
    }
    , {
      id: 'pricePer'
      , label: 'PRICE PER'
      , path: 'pricePer'
      , Cell: (value) => (
        <StyledUnitCell>
          <LabelDollarFormatted value={value.value} decimals={0} />
          { value.unit && <LabelString className="unit" value={value.unit} />}
        </StyledUnitCell>
      )
    }
  ];

  mapProperties = () => {
    const { properties } = this.props;

    return properties.map(property => {
      const isMultiFamily = property.assetTypeId === PROPERTY_ASSET_TYPES.MULTIFAMILY;
      const value = isMultiFamily ? property.pricePerUnit : property.pricePerSquareFoot;
      const unit = isMultiFamily ? 'unit' : 'foot';

      return {
        ...property
        , pricePer: {
          value
          , unit: !!value ? unit : null
        }
      };
    })
  }

  render() {
    const { properties } = this.props;
    if (!properties.length) return null;

    return (
      <StyledBaseTable
        columns={this.columns}
        onRowClick={item => this.props.redirect(item.id)}
        items={this.mapProperties()}
      />
    );
  }
}
